<template>
  <container v-if="elevations && elevations.length" :class="['elevation']">
    <h-three :title="title" />
    <flex :spacing="3">
      <flex-col md12 equal-height v-ripple @click.native="$emit('input', setElevation(elevation))" v-if="!['shadow-none-up', 'shadow-inner-up'].includes(setElevation(elevation))" v-for="(elevation, index) in elevations" :span="3" :key="index" :title="$lang.clickToCopy" :class="['text-center', 'bg-gray-100', setElevation(elevation), 'm-2', 'cursor-pointer']">
        <code v-html="setElevation(elevation, true)" :class="['text-xs', 'text-black', 'block', 'py-4', 'px-2']" />
      </flex-col>
<!--      <flex-col equal-height :span="6" :class="['m-2']" />-->
<!--      <flex-col equal-height :span="6" :class="['m-2']" />-->
    </flex>
  </container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'ElevationSwatches',
  mixins: [
    methods
  ],
  props: {
    elevations: {
      type: Array,
      default: () => []
    },
    negative: {
      type: Boolean
    },
    title: {
      type: String
    }
  },
  methods: {
    setElevation (elevation, asCssClass) {
      return `${asCssClass ? '.' : ''}shadow-${elevation}${this.negative ? '-up' : ''}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elevation-swatches.vue